import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import LeftSidebar from '../../components/LeftSidebar';
import { MainContentWrapper } from '../../components/LeftSidebar/styled';

const DashboardLayout = observer(() => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const location = useLocation();

  // Check if we're on the onboarding page
  const isOnboarding = location.pathname.includes('/onboarding');

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Listen for sidebar collapse state changes
  useEffect(() => {
    const handleSidebarToggle = (event) => {
      setSidebarCollapsed(event.detail.collapsed);
    };

    window.addEventListener('sidebarToggle', handleSidebarToggle);
    return () => window.removeEventListener('sidebarToggle', handleSidebarToggle);
  }, []);

  return (
    <>
      {/* Hide LeftSidebar during onboarding */}
      {!isOnboarding && <LeftSidebar />}
      {isDesktop && !isOnboarding ? (
        <MainContentWrapper sidebarCollapsed={sidebarCollapsed}>
          <Outlet />
        </MainContentWrapper>
      ) : (
        <div>
          <Outlet />
        </div>
      )}
    </>
  );
});

export default DashboardLayout;
